import { PatientService } from 'src/app/shared/patient.service';
import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotificationService } from 'src/app/notification.service';

@Component({
  selector: 'app-confirmation-dialog',
  templateUrl: './confirmation-dialog.component.html',
  styleUrls: ['./confirmation-dialog.component.css']
})
export class ConfirmationDialogComponent implements OnInit {

  constructor(@Inject(MAT_DIALOG_DATA) public data,public dialogRef:MatDialogRef<ConfirmationDialogComponent>,
  public pservice:PatientService,private notificationService: NotificationService,) { }

  ngOnInit(): void {
  }
  onDismiss(){
    this.dialogRef.close();
  }
  onConfirm(){
    this.pservice.CancelOrder(this.data).subscribe(res =>{
      if(res != 0){
        this.notificationService.warn("Order Cancelled")
      }
      else{
        this.notificationService.warn("Something went wrong!")
      }
    })
    this.dialogRef.close();
  }
}
